
      import { cdn } from './src/js/environments.js';
      // Set the global CDN variable
      window.AEM_CDN = cdn;
      console.log('AEM_CDN:', cdn);
    